import axios from 'axios';
// config

import {AUTH} from "../auth/FirebaseContext";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
    baseURL: '/', headers: {
        'ApiKey': '',
        'Accept': 'text/plain',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
});

axiosInstance.interceptors.request.use(
    (config) => {
        if (typeof config.data === 'string') {
            config.headers = {
                ...config.headers,
                'Authorization' :  `Bearer ${AUTH.supplier.stsTokenManager.accessToken}`,
                'Content-Type' : 'application/xml',
                'Accept' : 'application/xml'
            }

        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const statusCode = error.response?.status;
        const errorData = error.response?.data;
        return Promise.reject({statusCode, errorData});
    }
);

const BSS_URL = "https://europe-central2-esir-44ade.cloudfunctions.net/esir"

const customAxios = (token) => axios.create({
    baseURL: BSS_URL,
    headers: {
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`,
    },
});

export async function getClientInfo(tin) {
    const token = await AUTH.currentUser.getIdToken(true);
    const PIB = tin?.tin || tin
    if(PIB !== undefined && typeof PIB !== 'object' && PIB.length > 8 && PIB.length < 14){
        return customAxios(token).get(`/getCompanyDetails?TIN=${PIB}`);
    }
    return ""
}

export default axiosInstance;


